import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      layout: {
        ...store.getState().i18n.translations.en.layout,
        footer: {
          TITLE1: `Data on this platform was compiled using information deemed
          reliable at the time of publication.`,
          TITLE2: `FiinGroup makes no representation or warranty regarding the
          completeness or accuracy of such information. Review our data policy
          to learn more.`,
          CONTENT: '© FiinGroup JSC. %{year}. All rights reserved.',
          PRIVACY_POLICY: 'Privacy Policy',
          TERMS_OF_USE: 'Terms of Use',
          DATA_POLICY: 'Data Policy',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      layout: {
        ...store.getState().i18n.translations.vi.layout,
        footer: {
          TITLE1: `Dữ liệu trên nền tảng này được tổng hợp dựa trên các thông
          tin được cho là đáng tin cậy tại thời điểm xuất bản.`,
          TITLE2: `FiinGroup không đưa ra bất kì tuyên bố nào về tính đầy đủ
          hoặc chính xác của những thông tin đó. Để biết thêm thông tin, vui
          lòng xem chính sách dữ liệu của FiinGroup.`,
          CONTENT: '© %{year}. Toàn bộ bản quyền thuộc về FiinGroup JSC.',
          PRIVACY_POLICY: 'Chính sách bảo mật',
          TERMS_OF_USE: 'Điều khoản sử dụng',
          DATA_POLICY: 'Chính sách dữ liệu',
        },
      },
    },
  }),
)
